
import findLinkEntities from '../../helpers/findLinkEntities'

describe('findLinkEntities', () => {
  it('should call fnc', () => {
    const contentBlock = {
      key: '5ppe',
      type: 'unsytled',
      text: "testing",
      findEntityRanges: () => {
        return ([{
          getEntity: () => {
            return '1'
          }
        }])
      }
    }
    const contentState = {
      getEntity: (content) => {
        if (content === '1') {
          return ({
            getType: () => {
              return 'LINK'
            }
          })
        }
      }
    }
    const callback = () => { }
    const statergy = findLinkEntities(contentBlock, callback, contentState)
    expect(statergy).toBeUndefined();
  })
  
})